import { ConditionsManager } from '@/shared/components/conditions/models/conditionsManager';
import {store} from '@/store';
import {ConditionPickerOption} from '@/shared/components/conditions/models/conditions';

export class AudienceConditionsManager extends ConditionsManager {
	constructor() {
		super(store.getters.allContactAttributes);
	}

	get visibleConditions(): ConditionPickerOption[] {
		const nonArchivedAttributes = this.conditions.filter(option => {
			const attributeId = option.id.substring(option.id.lastIndexOf('.') + 1);
			return !store.getters.isAttributeArchived(attributeId);
		});
		return nonArchivedAttributes;
	}
}
